module.exports = __webpack_public_path__ + "static/media/14b.6c7c2e71.jpg";